<template>
    <ComLoading v-if="!nimikkeet" />
    <div v-else class="card-margin-bottom">
        <el-row>
            <el-col>
                <el-form-item>
                    <ComCascaderSearch v-model="hakuModel" />
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-cascader-panel 
                :options="nimikkeet" 
                :props="{
                    disabled: false,
                    multiple: true,
                }" 
                v-model="valitutNimikkeet" />
            </el-col>
        </el-row>
        <ComHuonekorttiValinta v-model="huonekorteittain" />
    </div>
</template>

<script setup lang="ts">
import ComCascaderSearch from "@/components/common/ComCascaderSearch.vue";
import ComLoading from "@/components/common/ComLoading.vue"
import ComHuonekorttiValinta from "./ComHuonekorttiValinta.vue"
import { useHakuSelection } from "@/methods/hakuSelectionComposables";
import { setNodes, useNimikeKategoria } from "@/methods/nimikkeetComposables";
import { defineModel, ref, toRef, watch, watchEffect } from "vue"

const emit = defineEmits<{ nimikkeet: [value: number[]] }>()
const huonekorteittain = defineModel<boolean>("huonekorteittain", { default: false })
const { nimikeKategoriat } = useNimikeKategoria(toRef(true))
const valitutNimikkeet = ref<[number, number, number][]>([])
const { model: hakuModel} = useHakuSelection(valitutNimikkeet)
const nimikkeet = ref()

watch(valitutNimikkeet, () => {
    let n: number[] = []

    if (valitutNimikkeet.value) {
        n = valitutNimikkeet.value?.map((v: number[]) => {
            return v[2]
        })
    }

    emit("nimikkeet", n)
})

watchEffect(() => {
    nimikkeet.value = setNodes(nimikeKategoriat.value ?? [], true)
})

</script>
